// `uninstall.page.tpl.html` — the page Chrome opens when the extension is removed. The whole
// template is the logo:
//
//     <div class="chrome-extension-uninstall-page">
//       <img class="logo" src="/static/assets/img/woo/logo.svg">
//     </div>
//
// ⚠️ IT HAS NO REFERENCE CAPTURE, AND THE MANIFEST SAYS WHY. A page whose visible text is zero
// characters is indistinguishable from a page that never painted, so the capture files it as
// `renders-nothing-signed-out` rather than as a baseline — deliberately, because the alternative
// is relaxing the blank-page refusal that exists to stop a failure being photographed. So this
// screen is ported from the template and NOT verified against pixels, which is a weaker claim
// than every other screen on the branch and is recorded as such in `manifest.ts`.
//
// The state declares `?isFirstInstall&version`, and the template reads neither: upstream's
// controller is empty. They are there for the analytics the install/uninstall flow sends, which
// is the shell's (Phase 6).
import type { ReactElement } from 'react'
import { PageHost } from '../auth/PageHost.tsx'
import { asset } from '../assetBase.ts'

export function UninstallPage(): ReactElement {
  return (
    <PageHost name="chrome-extension-uninstall-page">
      <img className="logo" src={asset('/static/assets/img/woo/logo.svg')} alt="" />
    </PageHost>
  )
}
